import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Flow } from "../../components";
import Navigation from "./Navigation";

const RepeatFlow = ({
  pages,
  onChange,
  activeIndex,
  isLoading: isLoadingProps,
}) => {
  const history = useHistory();
  const flowRef = useRef();
  const { validateForm } = useFormikContext();

  useEffect(() => {
    // force auto validation on values change (patch formik bug)
    setTimeout(() => {
      validateForm();
    }, 0);
  }, [activeIndex, pages]);

  return (
    <Flow.Router
      renderProgress={() => null}
      onChange={(step) => onChange(step, history)}
      ref={flowRef}
      routes={pages}
      initialStep={activeIndex}
    >
      {({ goNext, goTo, active }) => (
        <>
          <Navigation
            progress={(100 / (pages.length - 1)) * active}
            submitOnNext={active === pages.length - 1}
            goNext={goNext}
            isLoading={isLoadingProps}
            goTo={goTo}
            goBack={active > 0 ? () => goTo(active - 1) : null}
          />
        </>
      )}
    </Flow.Router>
  );
};

export default RepeatFlow;
